import { useLayoutEffect, useRef } from 'react';

export default function useScrollGuard<T>({
	isLoading,
	hasMoreData,
	onLoadMore,
	data,
}: {
	isLoading: boolean;
	hasMoreData: boolean;
	onLoadMore: () => void;
	data: T[];
}) {
	const loadingMoreRef = useRef(false);
	const scrollContainerRef = useRef<HTMLDivElement | null>(null);

	useLayoutEffect(() => {
		loadingMoreRef.current = false;
	}, [data.length]);

	useLayoutEffect(() => {
		if (isLoading) return;
		if (!hasMoreData) return;
		if (!data.length) return;
		if (loadingMoreRef.current) return;

		const el = scrollContainerRef.current;
		if (!el) return;

		const checkAndLoad = () => {
			if (loadingMoreRef.current) return;
			if (el.scrollHeight === 0) return;

			const canScroll = el.scrollHeight > el.clientHeight + 1;
			if (!canScroll) {
				loadingMoreRef.current = true;
				onLoadMore();
			}
		};

		const timeoutId = setTimeout(checkAndLoad, 150);

		return () => clearTimeout(timeoutId);
	}, [data.length, isLoading, hasMoreData, onLoadMore]);

	return { scrollContainerRef };
}
